import { useDispatch, useSelector } from "react-redux";
import { useEffect, useMemo } from "react";
import { fetchCatalogBanners } from "/redux/action-creaters/content";
import { useRouter } from "next/router";
import styles from "./index.module.scss";

export default function Banner({ cityName, sectionId }) {
  const dispatch = useDispatch();
  const { catalogBanners } = useSelector((state) => state.content);
  const router = useRouter();

  useEffect(async () => {
    await dispatch(fetchCatalogBanners(Boolean(router.query.reset)));
  }, []);

  const baner = useMemo(() => {
    return (
      Array.isArray(catalogBanners) &&
      catalogBanners.find((banner) => {
        if (
          banner.PROPERTY_SECTIONS_VALUE &&
          !banner.PROPERTY_SECTIONS_VALUE.includes(sectionId)
        ) {
          return false;
        }
        if (
          banner.PROPERTY_CITYS_VALUE &&
          banner.PROPERTY_CITYS_VALUE !== cityName
        ) {
          return false;
        }
        return true;
      })
    );
  }, [catalogBanners, cityName, sectionId]);

  return baner ? (
    <a href={baner.PROPERTY_LINK_VALUE} className={styles.Link}>
      <span dangerouslySetInnerHTML={{ __html: baner.PREVIEW_TEXT }}></span>
      <img className={styles.MobileBanner} src={baner.DETAIL_PICTURE} />
      <img className={styles.Banner} src={baner.PREVIEW_PICTURE} />
    </a>
  ) : null;
}
